import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";

interface Setting {
  key: string;
  value: string;
}

export const useSettings = (
  entityType: string,
  entityId: string | number
): {
  fetch: Omit<UseFetchResult<Setting[]>, "data">;
  data: Setting[];
} => {
  const { data, ...fetch } = useFetch<Setting[]>(
    `/api/${entityType}/${entityId}/settings`,
    {
      method: "get",
      initialData: [],
    }
  );

  return {
    fetch,
    data: data ?? [],
  };
};
